const isFlagOn = (value?: boolean | number | null): boolean =>
    Number(value) === 1 || value === true;

/** URL картки об'єкта / продажу / продажу послуг */
export const getObjectCardPath = (
    objectId: number,
    onlySale?: boolean | number | null,
    onlyService?: boolean | number | null,
): string => {
    const id = Number(objectId || 0);
    if (!id) return '/objects';
    if (isFlagOn(onlyService)) return `/service-sales/${id}`;
    if (isFlagOn(onlySale)) return `/sales/${id}`;
    return `/objects/${id}`;
};
